<template>
  <div class="exhibition-card">
    <div class="head">
      <div class="icon">
        <img :src="getIcon(info.info.type)" alt="" class="icon-img" />
      </div>
      <div class="title">{{ info.info.spiderClassName }}</div>
      <router-link :to="{ name: 'site_approval_list', query: routerLinkQuery }">更多>></router-link>
    </div>

    <div class="content">
      <div
        class="content-cell"
        v-for="(item, index) in fill12List"
        @click="toDetail(item)"
        :key="index"
      >
        <Avatar v-show="item.spiderId" :url="item.headImage" :type="info.info.type" />
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ item.spiderName }}
          </template>
          <span>{{ item.spiderName}}</span>
        </a-tooltip>
      </div>
    </div>

    <div class="foot">
      <router-link
        :to="{
          name: 'site_create_form',
          query: { type: info.info.type, spiderClassId: info.info.spiderClassId }
        }"
      >
        <div class="bt">开始创建</div>
      </router-link>
    </div>
  </div>
</template>

<script>
import Avatar from '../components/Avatar.vue'

export default {
  props: {
    info: Object
  },
  data() {
    return {
      iconMap: {
        weibo: require('../../../assets/Site/ExhibitionBoard/weibo.png'),
        news: require('../../../assets/Site/ExhibitionBoard/news.png'),
        toutiao: require('../../../assets/Site/ExhibitionBoard/toutiao.png'),
        facebook: require('../../../assets/Site/ExhibitionBoard/Facbook.png'),
        twitter: require('../../../assets/Site/ExhibitionBoard/twitter.png'),
        api: require('../../../assets/Site/ExhibitionBoard/API.png'),
        youtube: require('../../../assets/Site/ExhibitionBoard/youtube.png'),
        document: require('../../../assets/Site/ExhibitionBoard/document.png'),
        tg: require('../../../assets/Site/ExhibitionBoard/tg.png'),
        ins: require('../../../assets/Site/ExhibitionBoard/ins.png'),
        vk: require('../../../assets/Site/ExhibitionBoard/vk.png'),
        default: require('../../../assets/Site/ExhibitionBoard/default.png'),
        wechat: require('../../../assets/Site/ExhibitionBoard/wechat.png')
      }
    }
  },
  computed: {
    fill12List() {
      let children = this.info.data
      while (children.length < 12) {
        children.push({ spiderName: '' })
      }

      // console.log(children)
      return children
    },
    routerLinkQuery() {
      let type
      switch (this.info.info.type) {
        case 'news':
          type = 'news'
          break
        case 'api':
          type = 'api'
          break
        case 'weibo':
        case 'facebook':
        case 'twitter':
        case 'youtube':
          type = 'weMedia'
          break
        case 'toutiao':
          type = 'toutiao'
          break

        case 'tg':
          type = 'tg'
          break
        case 'ins':
          type = 'ins'
          break
        case 'vk':
          type = 'vk'
          break
        case 'document':
          type = 'document'
          break
        case 'wechat':
          type = 'wechat'
          break
        default:
          type = 'unknow'
      }
      return {
        spiderClassId: this.info.info.spiderClassId,
        typeSelect: this.info.info.type,
        type
      }
    }
  },

  methods: {
    getIcon(type) {
      return this.iconMap[type] || this.iconMap.default
    },
    toDetail(item) {
      var query = {}
      query['type'] = item.spiderClassType
      query['spiderId'] = item.spiderId
      this.$router.push({
        path: '/site_approval_list',
        query: query
      })
    }
  },

  components: {
    Avatar
  }
}
</script>

<style lang="less" scoped>
.exhibition-card {
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  background: white;

  .head {
    height: 84px;
    border-bottom: 1px solid #ebebeb;
    display: flex;
    align-items: center;
    padding: 0 30px;
    width: 100%;

    .icon {
      width: 42px;
      height: 42px;
      margin-right: 20px;
      border-radius: 50%;
      flex-shrink: 0;

      .icon-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .title {
      color: #1f2e4c;
      font-size: 22px;
      font-weight: 500;
      margin-right: auto;
      flex-shrink: 0;
    }
  }

  .content {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px 10px;
    padding: 24px 24px;
    overflow: hidden;

    .content-cell {
      cursor: pointer;
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      height: 24px;
      line-height: 24px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      span {
        margin-left: 10px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }

  .foot {
    width: 100%;
    margin-bottom: 30px;
    padding-right: 30px;
    display: flex;
    flex-direction: row-reverse;

    .bt {
      width: 120px;
      height: 40px;
      background: #3377ff;
      border-radius: 4px;
      text-align: center;
      line-height: 40px;
      color: #ffffff;
      transition: all 0.2s;

      &:hover {
        box-shadow: 0px 3px 20px 0px rgba(0, 0, 0, 0.15);
      }
    }
  }
}
</style>
